export function buildEmailDocument(rawHtml: string): string {
  const content = rawHtml.trim();
  if (!content) {
    return '<!doctype html><html><head><meta charset="utf-8" /><meta name="viewport" content="width=device-width, initial-scale=1" /></head><body></body></html>';
  }

  if (/<html[\s>]/i.test(content) || /<!doctype/i.test(content)) {
    return content;
  }

  return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <base target="_blank" />
    <style>
      html, body {
        margin: 0;
        padding: 0;
        background: #ffffff;
      }

      body {
        color: #111827;
      }

      img, table {
        max-width: 100%;
      }
    </style>
  </head>
  <body>${content}</body>
</html>`;
}
